import { render, staticRenderFns } from "./Authcallback.vue?vue&type=template&id=2691c04e"
import script from "./Authcallback.vue?vue&type=script&lang=js"
export * from "./Authcallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports